import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { useClientLogContext } from 'src/contexts/ClientLogContext';

import {
  eventLastReviewedStateAtom,
  setVirtualIdsAtom,
  updateLastReviewedDateTimeAtom,
} from './useEventLastReviewed.atom';

export const useEventLastReviewed = () => {
  const state = useAtomValue(eventLastReviewedStateAtom);
  return {
    eventLastReviewed: state.data,
    isLoading: state.isLoading,
    isCompleted: state.isCompleted,
  };
};

export const useEventLastReviewedOperations = () => {
  const { trackError } = useClientLogContext();
  const setVirtualIds = useSetAtom(setVirtualIdsAtom);
  const updateLastReviewedDateTime = useSetAtom(updateLastReviewedDateTimeAtom);

  const onSettingVirtualIds = useCallback(
    (virtualIds: string[]) => {
      try {
        setVirtualIds(virtualIds);
      } catch (error) {
        trackError(
          'EventConfigClient.getLastReviewedDateTimeForEvents',
          error as unknown as Error,
          { virtualIds }
        );
      }
    },
    [setVirtualIds, trackError]
  );

  const onUpdateLastReviewedDateTime = useCallback(
    (viagVirtId: string | null) => {
      try {
        updateLastReviewedDateTime(viagVirtId);
      } catch (error) {
        trackError(
          'EventConfigClient.updateLastReviewedDateTimeForEvent',
          error as unknown as Error,
          { viagVirtId }
        );
      }
    },
    [updateLastReviewedDateTime, trackError]
  );

  return {
    onSettingVirtualIds,
    onUpdateLastReviewedDateTime,
  };
};
